// extracted by mini-css-extract-plugin
export default {"headingYellow":"DefaultNotification_headingYellow__F1kYR","text":"DefaultNotification_text__JA6S9"};